<template>
  <div>
    <template slot="header">
      <div class="row">
        <div class="col-6">
          <h3 class="mb-0">{{ $t("CATEGORIES.CATEGORIES_LIST") }}</h3>
        </div>
        <div class="col-6 text-right">
          <base-button
            type="primary"
            icon
            size="sm"
            @click="addCategory()"
            v-if="$currentUserCan($permissions.PERM_CREATE_CATEGORIES)"
          >
            <span class="btn-inner--icon">
              <i class="fas fa-plus"></i>
            </span>
            <span class="btn-inner--text">
              {{ $t("CATEGORIES.ADD_CATEGORY") }}
            </span>
          </base-button>
        </div>
      </div>
    </template>
    <div>
      <div
        class="col-12 d-flex flex-wrap filter-row"
      >
        <div class="col-6 col-md-3">
          <base-input>
            <el-select
              class="select-primary pagination-select"
              v-model="pagination.perPage"
              :placeholder="$t('COMMON.PER_PAGE')"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>
        <div
          class="col-6 col-md-3"
          v-if="
            !filterOrganization &&
            $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)
          "
        >
          <base-input>
            <organization-selector
              @organizationChanged="
                (organizationId) => (selectedOrganization = organizationId)
              "
            />
          </base-input>
        </div>
        <div class="col-6 col-md-3">
          <base-input>
            <el-select
              :clearable="true"
              class="select-primary pagination-select"
              v-model="selectedActive"
              :placeholder="$t('COMMON.STATUS')"
            >
              <el-option
                class="select-primary"
                :label="$t('COMMON.ALL')"
                :value="null"
              />
              <el-option
                class="select-primary"
                :label="$t('CATEGORIES.ACTIVE')"
                :value="1"
              />
              <el-option
                class="select-primary"
                :label="$t('CATEGORIES.INACTIVE')"
                :value="0"
              />
            </el-select>
          </base-input>
        </div>
        <div class="col-6 col-md-3">
          <base-input
            v-model="query"
            type="search"
            prepend-icon="fas fa-search"
            :placeholder="$t('COMMON.SEARCH_HINT.NAME_OR_DESCRIPTION')"
            clearable
          />
        </div>

        <!--
        <div class="col-6 col-md-3">
          <base-input>
            <category-selector
              :allowNone="false"
              :placeholder="$t('CATEGORIES.PARENT_CATEGORY')"
              :multiple="false"
              :category="selectedParentCategory"
              :filterOrganization="selectedOrganization"
              @categoryChanged="
                (categoryId) => {
                  selectedParentCategory = categoryId;
                }
              "
            />
          </base-input>
        </div>
-->

        <!-- <div class="col-6 col-md-3">
          <base-input>
            <categories-selector
              :allowNone="false"
              :placeholder="$t('COMMON.CATEGORIES')"
              :showAll="false"
              :isOnlyModels="false"
              @categoryChanged="
                (categoriesIds) => {
                  selectedInCategoryIds = categoriesIds;
                }
              "
            />
          </base-input>
        </div> -->
      </div>

      <el-table
        class="table-responsive bg-grey text-white align-items-center table-flush"
        header-row-class-name="thead-light"
        :data="categories"
        @sort-change="sortChange"
      >
        <div slot="empty" v-if="loading">
          <img src="/img/loading.gif" style="height: 100px; width: 100px" />
        </div>
        <el-table-column
          :label="`${$t('CATEGORIES.ICON')}/${$t('CATEGORIES.COLOR')}`"
          prop="name"
          sortable="custom"
        >
          <template v-slot="{ row }">
            <div class="d-flex">
              <div class="">
                <img
                  v-if="row.icon"
                  :src="`${row.icon}`"
                  class="argon-image mb-2"
                  style="width: 50px"
                  alt=""
                />
                <img
                  v-else
                  src="/img/placeholder.jpg"
                  class="argon-image mb-2"
                  style="width: 50px"
                  alt=""
                />
              </div>
              <div
                class="ml-3 mt-1"
                :style="`height: 25px!important; width: 25px!important; border-radius: 8px; background-color:${row.color};`"
              ></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('COMMON.NAME')"
          prop="name"
          sortable="custom"
          min-width="200px"
        >
          <template v-slot="{ row }">
            {{ `${row.name}` }}
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('COMMON.REPORTING_NAME')"
          prop="name"
          sortable="custom"
          min-width="200px"
        >
          <template v-slot="{ row }">
            {{ `${row.reporting_name}` }}
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('COMMON.ORGANIZATION')"
          v-if="
            !filterOrganization &&
            $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)
          "
          min-width="200px"
        >
          <template v-slot="{ row }">
            <organization :organization="row.organization" />
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('CATEGORIES.PARENT_CATEGORY')"
          min-width="200px"
        >
          <template v-slot="{ row }">
            <span v-if="row.parent">
              <category :category="row.parent" />
            </span>
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('COMMON.STATUS')"
          min-width="100px"
        >
          <template v-slot="{ row }">
            <badge :type="row.active ? 'success' : 'danger'">
              {{
                row.active
                  ? $t("CATEGORIES.ACTIVE")
                  : $t("CATEGORIES.INACTIVE")
              }}
            </badge>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('COMMON.CREATED_AT')"
          prop="created_at"
          sortable="custom"
          min-width="150px"
        >
          <template v-slot="{ row }">
            {{ $timeZoneDateFormat(row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column min-width="100px" align="center">
          <div slot-scope="{ row }" class="table-actions">
            <el-tooltip
              :content="$t('COMMON.VIEW')"
              placement="top"
              v-if="$currentUserCan($permissions.PERM_VIEW_CATEGORIES)"
            >
              <a
                type="text"
                @click="viewCategory(row)"
                class="table-action"
                data-toggle="tooltip"
                style="cursor: pointer"
              >
                <i class="fas fa-eye"></i>
              </a>
            </el-tooltip>

            <el-tooltip
              :content="$t('COMMON.EDIT')"
              placement="top"
              v-if="$currentUserCan($permissions.PERM_EDIT_CATEGORIES)"
            >
              <a
                type="text"
                @click="editWarehouse(row)"
                class="table-action"
                data-toggle="tooltip"
                style="cursor: pointer"
              >
                <i class="fas fa-edit"></i>
              </a>
            </el-tooltip>

            <el-tooltip
              :content="$t('COMMON.DELETE')"
              placement="top"
              v-if="$currentUserCan($permissions.PERM_DELETE_CATEGORIES)"
            >
              <a
                type="text"
                @click="deleteWarehouse(row.id)"
                class="table-action table-action-delete"
                data-toggle="tooltip"
                style="cursor: pointer"
              >
                <i class="fas fa-trash"></i>
              </a>
            </el-tooltip>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div
      slot="footer"
      class="mt-5 col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
    >
      <div class="">
        <p class="card-category">
          {{
            $t("COMMON.DISPLAY_FROM_X_TO_X_OF_X_ENTRIES", {
              from: total ? from + 1 : 0,
              to: to,
              of: total,
            })
          }}

          <span v-if="selectedRows.length">
            &nbsp; &nbsp;
            {{ $t("COMMON.X_LINES_SELECTED", { count: selectedRows.length }) }}
          </span>
        </p>
      </div>
      <base-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Option,
  Select,
  Table,
  TableColumn,
  Tooltip,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { BasePagination } from "@/components";
import OrganizationSelector from "@/components/OrganizationSelector.vue";
// import CategoriesSelector from "@/components/CategoriesSelector.vue";
import Category from "@/components/Category.vue";

export default {
  name: "warehouse-list-table",

  components: {
    BasePagination,
    OrganizationSelector,
    // CategoriesSelector,
    Category,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },

  mixins: [requestErrorMixin],

  props: {
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
  },

  data() {
    return {
      query: null,
      selectedRows: [],
      sort: "-created_at",
      total: 0,
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [20, 50, 100, 500],
      },
      categories: [],
      loading: true,
      isModel: false,
      selectedOrganization: null,
      selectedParentCategory: null,
      selectedInCategoryIds: null,
      selectedActive: 1,
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
    filterOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    filterWarehouseableType: {
      handler: "getListDebounced",
      immediate: true,
    },
    filterWarehouseableId: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedParentCategory: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedInCategoryIds: {
      handler: "getListDebounced",
      immediate: true,
    },
    isModel: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedActive: {
      handler: "getListDebounced",
      immediate: true,
    },
    modelUsed: {
      handler: "getListDebounced",
      immediate: true,
    },
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      try {
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { search: encodeURIComponent(this.query) } : {}),
            ...(this.selectedActive !== null && this.selectedActive !== ""
              ? { active: this.selectedActive }
              : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
          include: "organization,parent",
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: { ...params.filter, organization: this.filterOrganization },
          };
        }
        if (this.selectedOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.selectedOrganization,
            },
          };
        }

        if (this.selectedParentCategory) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              in_parent_category: this.selectedParentCategory,
            },
          };
        }

        if (this.selectedInCategoryIds) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              in_categories: this.selectedInCategoryIds.map((item) => item.id),
            },
          };
        }

        await this.$store.dispatch("categories/list", params);
        this.categories = this.$store.getters["categories/list"];
        this.total = this.$store.getters["categories/listTotal"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async deleteWarehouse(id) {
      const confirmation = await swal.fire({
        title: this.$t("CATEGORIES.DELETE_THIS_CATEGORY"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch("categories/destroy", id);
          await this.getList();
          this.$notify({
            type: "success",
            message: this.$t("CATEGORIES.CATEGORY_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    viewCategory(category) {
      this.$router.push({
        name: "View Category",
        params: { id: category.id },
      });
    },

    async editWarehouse(row) {
      this.$router.push({
        name: "Edit Category",
        params: { id: row.id },
      });
    },

    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
  },
};
</script>
